import * as React from 'react';
import { useSelector } from 'react-redux';
import { TableHeader } from './TableHeader';
import {
  selectIsSubscription,
  selectIsPublicationSubscription,
} from '../../../../../../../../selectors/buyPackageModal';
import { getContentColTitle, getPointsColTitle, getPriceColTitle } from './utils';

interface ITableHeaderContainerProps {
  durationCol: boolean;
  auctionPointsCol: boolean;
}

export const TableHeaderContainer = (props: ITableHeaderContainerProps) => {
  const { durationCol, auctionPointsCol } = props;
  const isSubscription = useSelector(selectIsSubscription);
  const isPublicationSubscription = useSelector(selectIsPublicationSubscription);

  const contentColTitle = React.useMemo(() => getContentColTitle(isSubscription), [isSubscription]);
  const priceColTitle = React.useMemo(() => getPriceColTitle(isPublicationSubscription), [isPublicationSubscription]);
  const pointsColTitle = React.useMemo(() => getPointsColTitle(isPublicationSubscription), [isPublicationSubscription]);

  return (
    <TableHeader
      contentColTitle={contentColTitle}
      pointsColTitle={pointsColTitle}
      priceColTitle={priceColTitle}
      durationCol={durationCol}
      auctionPointsCol={auctionPointsCol}
      isPointsHintAvailable={isPublicationSubscription}
    />
  );
};
